export const COOKIE_ACCESS = 'authToken'
export const COOKIE_REFRESH = 'refreshToken'
export const COOKIE_USER = 'userToken'
